import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';

@Component({
  selector: 'app-modal-error.',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss']
})
export class ModalErrorComponent implements OnInit {
  icon: any;
  labelTitile: string;
  textDescription: any;
  status: any;

  //KFSC - 28-08-2021
  QtyCarrito: number;
  QtyRequerida: number;
  QtyDisponible: number;
	QtyEntregaInmediata: number;
	QtyDisponibleReabastece: number;
	QtyDias: number;
  IsKitItem: boolean;
  UpdateOption: Boolean;
  //=================
  retValue = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<ModalErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMessage: DataMessageModel) {
    if (this.dataMessage !== null && this.dataMessage !== undefined) {
      this.labelTitile = this.dataMessage.labelTitile;
      this.icon = this.dataMessage.icon;
      this.textDescription = this.dataMessage.textDescription;
      this.status = this.dataMessage.status;

      //KFSC - 28-08-2021
      this.QtyCarrito = this.dataMessage.QtyCarrito;
      this.QtyRequerida = this.dataMessage.QtyRequerida;
      this.QtyDisponible = this.dataMessage.QtyDisponible;
      this.QtyEntregaInmediata = this.dataMessage.QtyEntregaInmediata;
      this.QtyDisponibleReabastece = this.dataMessage.QtyDisponibleReabastece;
      this.QtyDias = this.dataMessage.QtyDias;
      this.IsKitItem = this.dataMessage.IsKitItem;
      this.UpdateOption = this.dataMessage.UpdateOption;
      //=================

    } else {
      this.labelTitile = 'Lo sentimos parece que algo anda mal';
    }
  }
  ngOnInit() {
  }

  returnValue(ret) {
    this.retValue.emit(ret);
    this.dialogRef.close();
  }

}
